import PropTypes from 'prop-types';
import React from 'react';
import { withDefaultLandingPage } from '@bingads-webui-campaign-react/with-default-landing-page';
import { StyledPageMenu } from './page-menu';


class DefaultLandingPage extends React.PureComponent {
  constructor(props) {
    super(props);
    if (props.appPerfMarker) {
      this.campaignPageMenuPerfMarker = props.appPerfMarker.createChild('Campaigns_Page_Menu');
      this.markAction('willInit');
    }
  }

  markAction = (action) => {
    if (this.campaignPageMenuPerfMarker && action) {
      this.campaignPageMenuPerfMarker[action]();
    }
  }

  render() {
    this.markAction('willRender');

    return (
      <StyledPageMenu
        perfMarker={this.campaignPageMenuPerfMarker}
        defaultLandingPage={this.props.defaultLandingPage}
        setLandingPage={this.props.setLandingPage}
        {...this.props}
      />
    );
  }
}

DefaultLandingPage.propTypes = {
  appPerfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
  defaultLandingPage: PropTypes.string.isRequired,
  setLandingPage: PropTypes.func.isRequired,
};

export const PageMenuWithDefaultLandingPage = withDefaultLandingPage(DefaultLandingPage);
